// bootstrap_state 的前端镜像。
//   unknown → 拉取中
//   required → 仍可进入业务路由；如需手动初始化可访问 /welcome
//   completed → 初始化已完成
import { create } from 'zustand';
import type { BootstrapStateBody } from '../bootstrap/api';

export type BootstrapStatus = 'unknown' | 'required' | 'completed' | 'error';

export interface BootstrapStoreState {
  status: BootstrapStatus;
  state: BootstrapStateBody | null;
  error: string | null;
  setState: (body: BootstrapStateBody) => void;
  setError: (message: string) => void;
  reset: () => void;
}

export const useBootstrapStore = create<BootstrapStoreState>((set) => ({
  status: 'unknown',
  state: null,
  error: null,
  setState: (body) =>
    set({
      status: body.completed ? 'completed' : 'required',
      state: body,
      error: null,
    }),
  setError: (message) =>
    set({ status: 'error', error: message, state: null }),
  reset: () => set({ status: 'unknown', state: null, error: null }),
}));
